import React from "react"
import Navbar from "../navbar/Navbar"
import style from "./Page.module.css"
import Footer from "../Footer/Footer"
import CartSidebar from "../CartSidebar/CartSidebar"

const Page = ({
  title,
  children,
  is_admin = false,
  searchDisabled = false,
}) => {
  return (
    <>
      <title>{`${title} | Dr MM`}</title>
      <CartSidebar />
      <span className={is_admin ? style.admin_wrapper : style.normal_wrapper}>
        <Navbar
          current={title}
          is_admin={is_admin}
          searchDisabled={searchDisabled}
        />
        <section
          className={`${
            !searchDisabled
              ? style.page_padding_with_search_bar
              : style.normal_padding
          } ${is_admin ? style.admin_width : style.normal_width}`}
        >
          <div className={is_admin ? style.admin_content_inner : style.normal_content_inner}>
            {children}
          </div>
        </section>
      </span>
      {!is_admin && <Footer />}
    </>
  )
}

export default Page
